import React from 'react';
import './Ticker.css';

const items = [
  'aXtion Telemed', 'Electronic Health Records', 'Student Portal',
  'Telehealth Platform', 'HIPAA Compliant', 'FHIR Interoperability',
  'Remote Patient Care', 'Academic Management', 'Digital Health',
];

const Ticker = () => {
  const doubled = [...items, ...items];

  return (
    <div className="ticker">
      <div className="ticker-track">
        {doubled.map((item, i) => (
          <span key={i} className="ticker-item">
            <span className="ticker-diamond">◆</span>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
